import { render } from "./birthday-list.vue?vue&type=template&id=8ad049f6&scoped=true"
import script from "./birthday-list.vue?vue&type=script&lang=js"
export * from "./birthday-list.vue?vue&type=script&lang=js"

import "./birthday-list.vue?vue&type=style&index=0&id=8ad049f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ad049f6"]])

export default __exports__